var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6811 12.3232C24.9719 13.0684 24.9719 14.9316 23.6811 15.6768L6.25516 25.7377C4.96435 26.483 3.35083 25.5514 3.35083 24.0609V3.93911C3.35083 2.4486 4.96435 1.51704 6.25516 2.26229L23.6811 12.3232Z",
    fill: "currentColor"
  })));
};
export default SvgPlay;